/* eslint-disable max-len */
export default {
  title: 'Schedule',
  subtitle: 'View and manage your upcoming care shifts',
  noEvents: 'No events planned for this day',
  Today: 'Today',
  Helmet: {
    title: 'Quilt: Your events',
  },
  client: {
    status: {
      Unconfirmed: 'Unconfirmed',
      ShiftConfirmation: 'Confirmed',
      ClockInConfirmation: 'Clocked In',
      ClockOutConfirmation: 'Clocked Out',
      Reschedule: 'Requested Reschedule',
      Cancelled: 'Requested Cancel',
    },
  },
  Styles: {
    ShiftConfirmation: 'Confirmed',
    ClockInConfirmation: 'Clocked In',
    ClockOutConfirmation: 'Clocked Out',
    Unconfirmed: 'Unconfirmed',
    RequestedReschedule: 'Requested Reschedule',
    RequestedCancel: 'Requested Cancellation',
    Cancelled: 'Cancelled',
    Rescheduled: 'Rescheduled',
    LiveIn: 'Live In',
  },
  eventDetail: {
    clientInformation: 'Client Information',
    caregiverInformation: 'Caregiver Information',
    phone: 'Phone',
    address: 'Address',
    shiftTime: 'Shift Time',
    date: 'Date',
    time: 'Time',
    duration: 'Duration',
    status: 'Status',
    notes: 'Notes',
    noNotes: 'No Additional Notes',
    noEmail: 'No Email Provided',
    TimeSection: {
      Title: 'Shift Time',
      hour: 'hour',
      hours: 'hours',
    },
    noPhone: 'No Phone Provided',
    reschedule: 'Reschedule',
    cancel: 'Cancel',
  },
  ReimbursementSection: {
    Title: 'Reimbursements',
    Amount: '$#{expenses}',
  },
  EventTimelineSection: {
    Title: 'Event Timeline',
    ShiftConfirmed: {
      Title: 'Shift Confirmed ',
      Description: '#{caregiverName} confirmed this shift',
    },
    ShiftClockedIn: {
      Title: 'Clocked In ',
      Description: '#{caregiverName} clocked in',
      ClockinTime: 'Clock-In Time',
      EditedClockinTime: 'Edited Clock-In Time',
      Location: 'Location',
      NoLocation: 'No Location',
      Notes: 'Notes',
      NoNotes: 'No Additional Notes',
    },
    ShiftClockedOut: {
      Title: 'Clocked Out ',
      Description: '#{caregiverName} clocked out',
      ClockoutTime: 'Clock-Out Time',
      EditedClockoutTime: 'Edited Clock-Out Time',
      Location: 'Location',
      NoLocation: 'No Location',
      Notes: 'Notes',
      NoNotes: 'No Additional Notes',
      CareviewSummary: 'Careview Summary',
      NoAnswer: 'No Answer Provided',
    },
    ShiftRescheduled: {
      Title: 'Requesting To Rescheduled ',
      Description: '#{caregiverName} is requesting to reschedule this event to #{date} #{time}.',
      Reason: 'Reason for Rescheduling Shift: ',
      NoReason: 'No reason mentioned',
      RequestDeclined: 'Request Declined',
    },
    ShiftCancelled: {
      Title: 'Requesting To Cancel',
      Description: '#{caregiverName} is requesting to cancel this event.',
      Reason: ' Reason for Rejecting Shift: ',
      NoReason: 'No reason mentioned',
      RequestDeclined: 'Request Declined',
    },
    RecordCreation: {
      Title: 'Record Created ',
      Description: 'This event has been created.',
    },
  },
  Reason: {
    Reason: 'Reason',
    ReasonForCancel: 'Enter reason for cancellation..',
    ReasonForReschedule: 'Enter reason for rescheduling..',
    ReasonForCaregiver: 'Enter reason for changing caregiver..',
  },
  CancelEvent: {
    Title: 'Cancel Event',
    CancelConfirm: 'Are you sure you want to cancel this event?',
    confirm: 'Confirm',
  },
  RescheduleDialogTitle: {
    Title: 'Reschedule Event',
    Date: 'Date',
    StartTime: 'Start Time',
    EndTime: 'End Time',
    Timezones: 'Timezones',
  },
  AcceptCancelDialog: {
    Title: 'Accept Cancellation Request',
    Description: 'Are you sure you want to accept this request to cancel this shift?',
  },
  AcceptRescheduleDialog: {
    Title: 'Accept Reschedule Request',
    Description: 'Are you sure you want to accept this request to reschedule this shift?',
  },
};
